import axios from "axios";

export const axiosClient = axios.create();

axiosClient.defaults.baseURL = process.env.REACT_APP_API_SERVER_URL;

axiosClient.defaults.headers = {
    "Content-Type": "application/json",
} as any;

export function getRequest(URL: string) {
    return axiosClient.get(`/${URL}`).then((response) => response);
}
export function postRequest(URL: string, payload: unknown) {
    return axiosClient
        .post(`/${URL}`, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (error?.response) return error.response;
            return error;
        });
}
